import React from 'react'
import { connect } from 'react-redux'
import {
  fetchUserNotes,
  fetchLicenseNotes,
  fetchGroupNotes,
  fetchCustomerNotes,
  upsertNote,
  removeNote,
} from '../actions/note-actions'
import FontAwesome from 'react-fontawesome'
import classNames from 'classnames'

import ConfirmModal from './ConfirmModal'
import Note from './Note'
import PropertyTitle from './PropertyTitle'

class NotesOverview extends React.Component {
  constructor() {
    super()
    this.state = { show: false }
  }

  componentDidMount() {
    this.reloadNotes()
  }

  onSubmit(note) {
    if (this.props.user) {
      note.user = this.props.user
    }
    if (this.props.license) {
      note.license = this.props.license
    }
    if (this.props.group) {
      note.group = this.props.group
    }
    if (this.props.customer) {
      note.customer = this.props.customer
    }

    this.props.upsertNote(note).then(() => this.reloadNotes())
  }

  onDelete(note) {
    this.confirmModal.show(() => {
      this.props.removeNote(note.id).then(() => this.reloadNotes())
    })
  }

  reloadNotes() {
    const { user, license, group, customer } = this.props
    if (user) {
      this.props.fetchUserNotes(user.id)
    } else if (license) {
      this.props.fetchLicenseNotes(license.id)
    } else if (group) {
      this.props.fetchGroupNotes(group.id)
    } else if (customer) {
      this.props.fetchCustomerNotes(customer.id)
    }
  }

  toggleShow() {
    this.setState({ show: !this.state.show })
  }

  render() {
    const { notes } = this.props
    return (
      <div className={classNames('note-overview', { show: this.state.show })}>
        {this.state.show ? (
          <div>
            <FontAwesome className="close-notes" name="times" size="lg" onClick={() => this.toggleShow()} />
            <PropertyTitle text="Notities" />
            <Note new note={{}} onSubmit={(text) => this.onSubmit(text)} readonly={false} />
            <div className="notes" data-size={notes.length}>
              {notes.map((note, index) => (
                <Note
                  key={note.id}
                  note={note}
                  onSubmit={(note) => this.onSubmit(note)}
                  onDelete={(note) => this.onDelete(note)}
                  readonly={true}
                />
              ))}
            </div>
            <ConfirmModal
              ref={(ref) => (this.confirmModal = ref)}
              message="Weet je zeker dat je deze notitie wilt verwijderen?"
            />
          </div>
        ) : (
          <div className="open-notes" onClick={() => this.toggleShow()}>
            <FontAwesome name="comment-o" size="3x" />
            <span className="amount">{notes.length}</span>
          </div>
        )}
      </div>
    )
  }
}

export default connect(
  (state) => {
    return { notes: state.notes.noteList }
  },
  {
    fetchUserNotes,
    fetchLicenseNotes,
    fetchGroupNotes,
    fetchCustomerNotes,
    upsertNote,
    removeNote,
  }
)(NotesOverview)
